import {
  GetExtendedUserDocument,
  useAddUserTagsMutation,
} from 'generated/graphql';
import { useCallback } from 'react';
import { apolloStatusToQueryStatus } from 'v2/core/repository/edge-server/statusConvertor';
import { EdgeResponse } from 'v2/core/repository/edge-server/types';
import { useGetUserMaybe } from 'v2/core/services/user';

export const useAddUserTags = (): [
  (tags: string[], shouldRefetchQueries?: boolean) => Promise<void>,
  EdgeResponse<unknown>,
] => {
  const user = useGetUserMaybe();

  const [addUserTagsMutation, { data, loading, error, called }] =
    useAddUserTagsMutation();

  const addUserTags = useCallback(
    async (tags: string[], shouldRefetchQueries?: boolean) => {
      if (!user?.id || !user.tenant.id) {
        return;
      }

      await addUserTagsMutation({
        variables: {
          userID: user.id,
          tenantID: user.tenant.id,
          tags,
        },
        refetchQueries: shouldRefetchQueries
          ? [GetExtendedUserDocument]
          : undefined,
      });
    },
    [addUserTagsMutation, user?.id, user?.tenant.id],
  );

  const status = apolloStatusToQueryStatus(loading, called, false, error);

  return [addUserTags, { data: data?.addUserTags, status, error }];
};
